import CondensingUnitTableSKU from './CondensingUnitTableSKU';

export default CondensingUnitTableSKU;
